import {PropsWithChildren} from 'react';

import {Card} from '@/shared/ui/card';
import {Title} from '@/shared/ui/typography';
import classNames from 'classnames';

import styles from './PassnoteApplyList.module.scss';

type PassnoteApplyListProps = {
  title: string;
  listCount: number;
  className?: string;
};

const PassnoteApplyList: React.FC<
  PropsWithChildren<PassnoteApplyListProps>
> = ({title, className, children, listCount}) => {
  return (
    <Card className={classNames(styles.PassnoteApplyList, className)}>
      <div className={styles.PassnoteApplyList__head}>
        <div className={styles.PassnoteApplyList__titleWrapper}>
          <Title>{title}</Title>
          <div>({listCount}명)</div>
        </div>
        <div className={styles.PassnoteApplyList__hint}>*최근 7일간 데이터</div>
      </div>
      <div className={styles.contents}>{children}</div>
    </Card>
  );
};

export default PassnoteApplyList;
